// Template Generated by DataExtraction.py at 1717541024
        
import CESGEnglishB2 from "../../Forms/CESG/CESG_EnglishB2.png";
import CESGEnglishB2Labels from "../../Labels/CESG/CESG_EnglishB2.json";
import CESGFrenchB2 from "../../Forms/CESG/CESG_FrenchB2.png";
import CESGFrenchB2Labels from "../../Labels/CESG/CESG_FrenchB2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchB2Labels : CESGEnglishB2Labels;
    const formImage = isFrench ? CESGFrenchB2 : CESGEnglishB2;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const now = moment().format("yyyy/MM/DD");

    // Drawing the form
    drawText(now, "primaryCaregiverSignDateYyyyMmDd");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchB2Labels : CESGEnglishB2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    const guardianRecipientId = POSSIBLE_SIGNERS['Guardian'];
    let signers = [];
    let signHereTabs = [];

    // signatureView1
    signers.push({
        [guardianRecipientId]: [signatureTab(guardianRecipientId, documentId, pageNumber, signatureLabel("signatureView1", labels))], // TODO MUST check if signer is correct!
    });
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    